/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * GTO Wizard API v4
 * API documentation for GTO Wizard frontend API
 * OpenAPI spec version: 4
 */
import { RelativePositionAndSeat } from './relative-position-and-seat'
import { CustomDisplayPosition } from './custom-display-position'

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GameSchemaActivePosition = {
  ...RelativePositionAndSeat,
  ...CustomDisplayPosition,
} as const
